module.exports = __webpack_public_path__ + "static/media/passport_pic.70f17d25.png";